// hide variant name unique characters

document.addEventListener("DOMContentLoaded", function () {
  function cleanText(el) {
    const text = el.textContent?.trim();
    if (text && text.includes("|")) {
      el.textContent = text.split("|")[0].trim();
    }
  }

  function cleanAllColorNames() {
    const fsApp = document.querySelector("#fast-simon-serp-app");
    if (!fsApp || !fsApp.shadowRoot) return;
    const root = fsApp.shadowRoot;

    // Clean static swatch names
    root.querySelectorAll(".color-swatch-color-name").forEach(cleanText);

    // Clean hover tooltip text if exists
    root.querySelectorAll(".fs-serp-tooltip, .color-tooltip, .swatch-tooltip").forEach(cleanText);
  }

  // Initial clean
  cleanAllColorNames();

  // Observe for DOM changes (grid updates or tooltip creation)
  const fsApp = document.querySelector("#fast-simon-serp-app");
  if (fsApp && fsApp.shadowRoot) {
    const observer = new MutationObserver(() => {
      requestAnimationFrame(cleanAllColorNames);
    });
    observer.observe(fsApp.shadowRoot, { childList: true, subtree: true });
  }
});
// hide variant name unique characters

var __fast_options = {
    with_product_attributes: true,
    category_filter_as_regular_facet: true,
    color_attribute_names: ['kleur', 'Farbe', 'Couleur Principale']
};

if(window.location.href.includes("/products") )
{
 __fast_options.disable_shadow_root="true";
}


function getProductElements(element) {
    return [...element.querySelectorAll(`.fs-results-product-card`)];
}
function cleanProductTitle(productElement, sel = '.fs-product-title') {
  const el = productElement?.querySelector(sel);
  if (!el) return false;

  const txt = (el.textContent || '').trim();
  const cutAt = txt.indexOf('|');
  if (cutAt === -1) return false;

  el.textContent = txt.slice(0, cutAt).trim();
  return true; // cleaned
}
// Global array
var myProductsArray = [];
var myACProductsArray = [];

function Getattributevalue(att, name) {
    if (typeof(att) !== "undefined" && att !== null) {
        for (let key in att) {
            if (att[key].color.toLowerCase() === name) {
                return att[key].variants[0].attributes.imgs[0];
            }
        }
    }

    return "";
}

const NewBadges = {
    set: (product, productElement) => {
        var $badgewapper = `<div class="fs-badges-wrapper"></div>`;
        if (productElement.querySelectorAll(`.fs-badges-wrapper`).length === 0) {
            productElement.querySelector(".image-wrapper").insertAdjacentHTML('afterBegin', $badgewapper);
        }

        if (NewBadges.isOnSale(product,productElement)) {
            NewBadges.addLabel(productElement, `<span class="fs_product_text_badge_flag sale">Sale</span>`);
        }
        else if(productElement.querySelector(`.fs_product_text_badge_flag.sale`))
        {
          productElement.querySelector(`.fs_product_text_badge_flag.sale`).remove();
        }
    },
    addLabel: (productElement, promolabel) => {
        const label = productElement.querySelector(`.fs_product_text_badge_flag`);
        if (label) {
            label.remove();
        }
        productElement.querySelector(".fs-badges-wrapper").insertAdjacentHTML('afterBegin', promolabel);
    },
    isSoldOut: (product) => {
        return ("isSoldOut" in product && product.isSoldOut)
    },
    isOnSale: (product,productElement) => {
        if (product) {
            const originalPrice = parseFloat(product.price);
            const price = parseFloat(product.comparePrice);
            return price && originalPrice && originalPrice > 0 && price > 0 && price > originalPrice;
        } else if(productElement && productElement.querySelector(".compare"))
        {
          return true;
        }
        else return false;
    }
};

//upsell ATC handler  
function productAddToCartCallback(productData) {
    var id = 0;
    if (productData && productData.productData && productData.productData.variants) {
        for (var variant of productData.productData.variants) {
            if (variant.attributes && variant.attributes.Sellable) {
                id = variant.id;
                break;
            }
        }
    } else if (Number(productData) > 0) {
        id = Number(productData);
    }
    if (id != 0) {
        const data = {
            'id': id,
            'quantity': 1
        };
        fetch(`${routes.cart_add_url}.js`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (document.body.querySelector("cart-drawer")) {
                document.body.querySelector("cart-drawer").classList.remove("is-empty");
                if (document.body.querySelector(".drawer__inner-empty")) {
                    document.body.querySelector(".drawer__inner-empty").remove();
                }
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {});
            publish(PUB_SUB_EVENTS.quantityUpdate, {});
        });
    }
}

window.addEventListener('fs-rec-custom-events-add-to-cart-click', (e) => {
    productAddToCartCallback(e.detail);
});

function getImageUrlByColorName(colors, colorName) {
    // Find the color object with the given name
    const colorObject = colors.find(color => color.value === colorName);

    // If the color is found, return its image URL, otherwise return null
    return colorObject ? colorObject.image : null;
}

function removecolorfromheader(element) {
    // Select the element by its class
    var titleElement = element.querySelector('.title.fs-product-title');

    // Check if the element is valid
    if (titleElement && titleElement.textContent) {
        // Get the current text content
        var currentText = titleElement.textContent;

        // Find the position of the first '-' sign
        var dashIndex = currentText.indexOf(' - ');

        // Remove text after the first '-'
        var updatedText = dashIndex !== -1 ? currentText.slice(0, dashIndex) : currentText;

        // Set the modified text back to the element
        titleElement.textContent = updatedText.trim(); // Trim to remove leading/trailing spaces
    } else {
        console.error('Invalid element or element without text content.');
    }
}

function returntitlewithoutcolor(element) {
    // Select the element by its class
    var titleElement = element.querySelector('.title.fs-product-title');

    // Check if the element is valid
    if (titleElement && titleElement.textContent) {
        // Get the current text content
        var currentText = titleElement.textContent;

        // Find the position of the first '-' sign
        var dashIndex = currentText.indexOf(' - ');

        // Remove text after the first '-'
        var updatedText = dashIndex !== -1 ? currentText.slice(0, dashIndex) : currentText;

        // Set the modified text back to the element
        return updatedText.trim(); // Trim to remove leading/trailing spaces
    } else {
        console.error('Invalid element or element without text content.');
        return null;
    }
}

function priceHandler(productElement) {
    if (productElement.querySelector(".info-container") && productElement.querySelector(".compare")) {
        productElement.querySelector(".info-container").style.gridTemplateAreas ='"vendor vendor vendor vendor" "title title title title" "compare price price price" "reviews reviews reviews reviews" "colorSwatches colorSwatches colorSwatches colorSwatches"';
    } else {
        productElement.querySelector(".info-container").style.gridTemplateAreas = '"vendor vendor vendor vendor" "title title title title" "price price price price" "reviews reviews reviews reviews" "colorSwatches colorSwatches colorSwatches colorSwatches"';
    }
    if (productElement.querySelector(".price")) {
        productElement.querySelector(".price").innerHTML = productElement.querySelector(".price").innerHTML.replace("From", "");
    }
}

function HideOOSfromAutocomplete(data, element) {
    if (typeof data === "undefined" || data === null) {
        return;
    }

    if ("iso" in data && data.iso) {
        if (element) {
            element.style.display = 'none';
        }
    }
}

function HideOOSgroupedproduct(data, element, id) {
    if (typeof data === "undefined" || data === null) {

        return;
    }

    if (typeof data.alternativeProducts === "undefined" || data.alternativeProducts === null) {
        if ("isSoldOut" in data && data.isSoldOut) {
            if (element) {
                element.style.display = 'none';
            }
        }

        return;
    }

    const alternativeProducts = data.alternativeProducts ?? null;

    if (alternativeProducts != null) {
        if (alternativeProducts.length > 0) {
            const isConditionMet = alternativeProducts.every(product => {
                // Check if Sellable is false in all variants
                const sellableCondition = product.variants.every(variant => variant.attributes.Sellable === false);

                // Check if 'Custom.parent product' exists under attributes in all variants
                const customParentProductCondition = product.variants.every(variant =>
                    variant.attributes.attributes.some(attribute => attribute[0] === 'Custom.parent product')
                );

                if (sellableCondition && customParentProductCondition) {
                    console.log("Product " , id , " is OOS - ", sellableCondition && customParentProductCondition);            
                    if (element) {
                        element.style.display = 'none';
                    }
                }
            });
        }
    } else {
        if ("isSoldOut" in data && data.isSoldOut) {
            if (element) {
                element.style.display = 'none';
            }
        }
    }
}

// Function to get object by string from array
function getObjectByString(title) {
    // Find the element in the array with the matching string
    const foundElement = myProductsArray.find((element) => element.string === title);

    // If the element is found, return the associated object; otherwise, return null
    return foundElement ? foundElement.generalObject : null;
}

// Function to add string and object to array if the string doesn't exist
function addStringAndObjectToArray(title, productelement, array) {
    // Check if the string already exists in the array
    const existingElement = array.find((element) => element.string === title);
    productelement.classList.remove('fs_hide');
    if (!existingElement && title) {
        // If it doesn't exist, add a new object to the array
        const newElement = {
            string: title,
            generalObject: productelement,
        };
        array.push(newElement);
    } else {
        // If it already exists, hide it      
        productelement.classList.add('fs_hide');
    }
}

//function for + sign of swatches
function otherSwatches(productElement, data) {
    const swatchesArr = productElement.querySelectorAll(".color-swatch:not(.fs-swatch-out-of-stock)");
    const showMore = productElement.querySelector(".show-more-swatches span span");
    var avialibleColors = 0;
    if (data && data.alternativeProducts) {
        for (var alternativeProduct of data.alternativeProducts) {
            for (var variant of alternativeProduct["variants"]) {
                if (variant["attributes"] && variant["attributes"]["Sellable"]) {
                    avialibleColors++;
                    break;
                }
            }
        }
    }
    var maxSwatches = "";
    if (window.innerWidth < 480) {
        maxSwatches = FAST_CONFIG.settings["mobileSettings"]["productGrid"]["product"]["colorSwatches"]["maxSwatches"];
    } else if (window.innerWidth >= 480 && window.innerWidth < 820) {
        maxSwatches = FAST_CONFIG.settings["tabletSettings"]["productGrid"]["product"]["colorSwatches"]["maxSwatches"];
    } else {
        maxSwatches = FAST_CONFIG.settings["desktopSettings"]["productGrid"]["product"]["colorSwatches"]["maxSwatches"];
    }
    if (swatchesArr && showMore && maxSwatches != "" && avialibleColors - parseInt(maxSwatches) <= 0) {
        console.log("product ID - ", data.id, " swatchesArr - ", swatchesArr, " maxSwatches - ", maxSwatches, " avialibleColors ", avialibleColors);
        productElement.querySelector(".show-more-swatches").style.display = "none";
    }
}

//global var, counter for filters
var URLGlobal = "";

function createCstmColorTooltip(swatchElement, tooltipText){
    if(swatchElement.querySelector('.cstm.fs-serp-tooltip')) return;
    swatchElement.insertAdjacentHTML('beforeend', `<div class="fs-serp-tooltip-cstm" style="border: 1px solid black; box-shadow: black 1px 1px 1px; background: black; border-radius: 4px; padding: 4px; font-size: 12px; position: absolute; top: 40px; left: 27px; color: white; z-index: 10000000; min-width: 62px;">${tooltipText}</div>`)
}
/* Add custom tooltip element for swatches that have an "| XXXX" text */
function fixSwatchColorText(element) {
  if (element.querySelector('.color-swatch-color-name') && element.querySelector('.color-swatch-color-name').textContent.includes('|')) {
    if(!element.classList.contains('cstm-hover-event')){
        element.classList.add('cstm-hover-event');
    }
    
    element.querySelectorAll(".color-swatch").forEach((swatch) => {
      if (!swatch.classList.contains('cstm')) {
        swatch.classList.add('cstm');

        // Add hover events
        swatch.addEventListener("mouseenter", () => {
          swatch.classList.add('swatch-hover');
        });

        swatch.addEventListener("mouseleave", () => {
          swatch.classList.remove('swatch-hover');
        });
        let swatchParent = swatch.closest('.color-swatch-container');
        if(swatchParent && swatchParent.querySelector('.color-swatch-color-name')){
            let tooltipText = swatchParent.querySelector('.color-swatch-color-name').textContent.replace(/\|.*$/, '').trim();
            createCstmColorTooltip(swatch,tooltipText)
        }
        
      }
    });
  }
}

function hooks() {
    window.SerpOptions.registerHook("serp-product-swatches", ({
        colors,
        swatchClick,
        showMoreClick,
        element
    }) => {
        const productElement = element.closest('.product-card');
        priceHandler(productElement);
        fixSwatchColorText(element);
        var isSwatch = "true";

        //badges on click
        element.querySelectorAll(".color-swatch").forEach((swatch)=>{
          if(!swatch.classList.contains('cstm-event'))
          {
            swatch.classList.add('cstm-event');
            swatch.addEventListener("click",()=>{
              setTimeout(()=>{
                NewBadges.set(null, swatch.closest('.product-card'));
              },20);
            });
          }

        });

        

        if (fast_simon_is_swatches === "") {                        
          // fast_simon_is_swatches is not defined
          console.log('fast_simon_is_swatches is not defined');          
        } else {
          // fast_simon_is_swatches is defined
          isSwatch = fast_simon_is_swatches;
        }        
                
        if (isSwatch === "false")  
          return;
      
        if (productElement) {
            var allColorSwatches = productElement.querySelectorAll(".color-swatch-container");
            if (allColorSwatches.length == 0) {
                productElement.querySelector(".color-swatches-wrapper").classList.add("one-color");
                removecolorfromheader(productElement);
            } else {
                allColorSwatches.forEach((swatchContainer)=> {
                    let colorName = swatchContainer.querySelector('.color-swatch-color-name').innerHTML;
                                   
                    removecolorfromheader(productElement);

                    // get the file from 'colors'                  
                    //var urlString = Getattributevalue(data.alternativeProducts,colorName);  
                    var urlString = getImageUrlByColorName(colors, colorName);

                    if (urlString === null)
                        return;

                    // Find the index of "jpg"
                    let index = urlString.indexOf('.jpg');

                    // Check if "jpg" exists in the string
                    if (index !== -1) {
                        // Remove the characters after "jpg"
                        urlString = urlString.substring(0, index);

                        // Add "_60x" before "jpg"
                        urlString += '_120x.jpg';
                    }
                    let swatch = swatchContainer.querySelector('.color-swatch');
                    swatch.style.backgroundImage = "url(" + urlString + ")";
                });
            }
        }
    });

    SerpOptions.registerHook('serp-product-grid', ({
        products,
        element
    }) => {
        const parent = element.closest("#fs-serp-page");
        for (const productElement of getProductElements(element)) {
            /* get product data */
            const productID = productElement.dataset.productId;
            const data = products[productID];
            if(data)
            {
                cleanProductTitle(productElement);
              otherSwatches(productElement, data);
  
              // need to check the tags (FS_SPLIT & Custom.parent_product) under alt object and hide products if all "alt" objects are OOS              
              HideOOSgroupedproduct(data, productElement, productID);
  
              var isSwatch = "true";
  
              if (fast_simon_is_swatches === "") {
                  isSwatch = "true";
              } else {
                  isSwatch = fast_simon_is_swatches;
              }
  
              if (isSwatch === "false" || isSwatch === false) {
                  productElement.querySelector(`.color-swatches-wrapper`).style.display = 'none';
              }
  
              if (!productElement.classList.contains('class-name')) {
                  // make a list of products title (after removing the color name). if the product is already included - hide it
                  var $title = returntitlewithoutcolor(productElement);
                  if (isSwatch === "true" || isSwatch === true) {
                    addStringAndObjectToArray($title, productElement, myProductsArray);  
                  }                
                  productElement.classList.add('class-name');
              }
  
              priceHandler(productElement);
  
              // add badges
              NewBadges.set(data, productElement);
              
            }
            
        }

        const __grid_elements = getProductElements(element);
        if (__grid_elements.length < 4) {
            const promoelement = element.querySelector('.fs-promo-tile-product-wrapper');
            if (promoelement) {
                promoelement.style.display = "none";
            }
        }

        var nowURL = window.location.href.indexOf('&') === -1 ? window.location.href.replace(/\?page=\d+/, '') : window.location.href.replace(/page=\d+&/, '');
        if (URLGlobal != nowURL && (nowURL.indexOf('filters')!=-1 || nowURL.indexOf('sort')!=-1)) {
            URLGlobal = nowURL;
            setTimeout(() => {
              myProductsArray = [];
              for (const productElement of getProductElements(element)) {
                  addStringAndObjectToArray(productElement.querySelector(".title").innerHTML, productElement, myProductsArray);
              }
              if(window.innerWidth>480)
              {
                window.scrollBy(0, 300);                
              }

            }, 1200);
        }
    });

    SerpOptions.registerHook('serp-filters', ({
        filters,
        element
    }) => {
        if (window.innerWidth < 480) {
            document.body.style.overflowY = "hidden";

            // Options for the observer (which mutations to observe)
            const config = {
                childList: true
            };

            // Create an observer instance
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    // Get the target node that triggered the mutation
                    const targetNode = mutation.target;
                    if (!targetNode.querySelector(".filters-modal-wrapper")) {
                        document.body.style.overflowY = "auto";
                    }
                });
            });

            // Target node to observe
            const targetNode = element.closest('.filters-modal-wrapper').parentNode;
            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }

        if (element) {
            //swatches title event
            element.querySelectorAll(".color-swatch-color-name").forEach((swatchName) => {
                if (!swatchName.classList.contains("cstm-event")) {
                    swatchName.classList.add("cstm-event");
                    swatchName.addEventListener("click", () => {
                        if (swatchName.closest(".color-swatch-container") && swatchName.closest(".color-swatch-container").querySelector(".color-swatch")) {
                            swatchName.closest(".color-swatch-container").querySelector(".color-swatch").click();
                        }
                    })
                }
            });

            if (window.location.href.indexOf('search-result') > -1) {
                let categoryItmes = element.querySelectorAll('.category-items > span');

                categoryItmes.forEach((el) => {
                    var str = "'" + el.querySelector('input[type="checkbox"]').getAttribute('aria-label') + "'";
                    if (SearchCategories.indexOf(str) > -1) {
                        el.style.display = "none";
                    } else {
                        if (str == "'Men'") {
                            el.style.order = "0";
                        } else if (str == "'Women'") {
                            el.style.order = "1";
                        } else {
                            el.style.order = "2";
                        }
                    }
                });

                if (window.innerWidth > 820) {
                    var es_categories = element.querySelector('#fs_filter_categories .category-items');
                    if (es_categories) {
                        document.querySelector('.collection-hero__text-wrapper').appendChild(es_categories);
                    }
                }
            }

            if (window.location.href.indexOf('collections') > -1) {
                console.log('Collection page for FS');
                if (window.location.href.indexOf('accessories') == -1 && window.location.href.indexOf('belts-1') == -1 && window.location.href.indexOf('socks') == -1 && window.location.href.indexOf('shoe-care') == -1) {
                    var __fast_size_button = `<modal-opener class="no-js-hidden" data-modal="#PopupModal-collection__page"><button class="size_guide_btn product-popup-modal__button link" type="button" aria-haspopup="dialog">${size_chart_btn_text}<img src="${size_chart_btn_img}" alt="Size Guide Icon" /></button></modal-opener>`;

                    let sizeFilter = element.querySelector('div[data-filter-id="Size"]');
                    if (sizeFilter && sizeFilter.querySelector('.size_guide_btn') == null) {
                        let sizeChartWrapper = document.createElement('div');
                        sizeChartWrapper.innerHTML = __fast_size_button;
                        sizeFilter.appendChild(sizeChartWrapper);
                    }
                }
            }

            //add X button to filter
            if (window.innerWidth < 480 && !element.querySelector(".fs-cstm-title-x-button-wrapper") && element.querySelector(".fs-filters-removable-tags")) {
                var filterTitleWrapper = document.createElement("div");
                filterTitleWrapper.classList.add("fs-cstm-title-x-button-wrapper");
                var filterTitleElement = document.createElement("div");
                filterTitleElement.innerHTML = "FILTER";
                filterTitleElement.classList.add("fs-cstm-filter-title");
                var xButtonElement = document.createElement("div");
                xButtonElement.innerHTML = "X  close";
                xButtonElement.classList.add("fs-cstm-filter-x-button");
                var backButtonElement = element.querySelector('.fs-close-filters-button');
                xButtonElement.addEventListener('click', () => {
                    if (backButtonElement) {
                        backButtonElement.click();
                    }
                });
                filterTitleWrapper.appendChild(filterTitleElement);
                filterTitleWrapper.appendChild(xButtonElement);
                element.querySelector(".fs-filters-removable-tags").insertBefore(filterTitleWrapper, element.querySelector(".fs-filters-removable-tags").firstChild);
            }

            const categoriesContainer = element.querySelectorAll('.category-container')
            if (categoriesContainer.length > 0) {
              categoriesContainer.forEach(categoryContainer => {
                let newValue = "";
    
                const ariaElement = categoryContainer.querySelector("[aria-controls]");
                if (ariaElement) {
                  let currentValue = ariaElement.getAttribute("aria-controls");
                  if (currentValue) {
                    newValue = currentValue.replace(/[\s.]/g, "-");
                    ariaElement.setAttribute("aria-controls", newValue);
                  }
                }
    
                const categoryItemsElement = categoryContainer.querySelector(".category-items");
                if (categoryItemsElement && newValue) {
                  categoryItemsElement.id = newValue;
                }
              });
            }
        }
    });

    window.SerpOptions.registerHook("serp-main-block", ({
        element,
        totalResults
    }) => {
        var noResElement = element.querySelector('.fs-no-results');
        var topCenterEl = element.querySelector('.top-center-container');
        var divider = element.querySelector('.divider');
        var es_featured__collection = document.querySelector('.es-featured__collection');
        var es_collection__banner = document.querySelector('.es-collection__banner');

        if (window.location.href.indexOf('collection')) {
            let _es_description = document.querySelector('.collection-hero__description');
            if (_es_description !== null && window.innerWidth > 820) {
                element.prepend(_es_description);
            }
        }

        var searchItemElement = document.getElementById("SearchItem");
        if (searchItemElement) {
            var queryString = window.location.href.split('?')[1];

            if (queryString) {
                var queryParams = queryString.split('&');
                var keyValue = queryParams.find(param => param.startsWith('q='));

                if (keyValue) {
                    var searchValue = keyValue.split('=')[1];
                    searchItemElement.innerText = decodeURIComponent(searchValue);
                } else {
                    // Handle the case where the 'q' parameter is not found
                    console.error("Query parameter 'q' not found in the URL.");
                }
            } else {
                // Handle the case where there is no query string in the URL
                console.error("No query string found in the URL.");
            }
        }

        if (!noResElement) {
            if (topCenterEl)
                topCenterEl.style.display = 'flex';
            if (divider)
                divider.style.display = '';
            if (es_featured__collection)
                es_featured__collection.style.display = 'none';
            if (es_collection__banner)
                es_collection__banner.style.display = 'block';
            return;
        }
        if (topCenterEl)
            topCenterEl.style.display = 'none';
        if (divider)
            divider.style.display = 'none';
        if (es_featured__collection)
            es_featured__collection.style.display = 'block';
        if (es_collection__banner)
            es_collection__banner.style.display = 'none';
        noResElement.innerText = '';
        noResElement.style.display = 'flex';
        noResElement.style.flexDirection = 'column';
        noResElement.style.fontFamily = "'Lexend',sans-serif";
        noResElement.style.fontSize = "16px";
        noResElement.style.fontWeight = "300";
        noResElement.style.textAlign = 'center';
        var mainTitleEl = document.createElement('div');
        var secondTitleEl = document.createElement('div');
        var bestSellersMsgEl = document.createElement('div');

        const path = window.location.pathname;
        const lang = path.split('/').filter(Boolean)[0].split("-")[0];

        mainTitleEl.style.alignSelf = 'center';
        mainTitleEl.style.fontWeight = '600';
        mainTitleEl.style.fontSize = '40px';
        mainTitleEl.style.textTransform = 'uppercase';
        mainTitleEl.style.letterSpacing = '1px';
        mainTitleEl.style.fontFamily = "'Sofia Sans Condensed',sans-serif"
        if(lang == "de") {
            mainTitleEl.innerText = 'KEINE TREFFER GEFUNDEN.';
            secondTitleEl.innerText = 'Entweder haben wir den Artikel nicht auf Lager, oder es liegt ein Tippfehler vor.';
            bestSellersMsgEl.innerHTML = "<div><span>Benötigen Sie Hilfe? </span><span>Schauen Sie sich unsere Bestseller oder Kollektionen an.</span></div>";
        }
        else if(lang == "es") {
            mainTitleEl.innerText = 'NO SE ENCONTRARON RESULTADOS.';
            secondTitleEl.innerText = 'O no lo tenemos en stock, o tienes que activar el corrector ortográfico. ';
            bestSellersMsgEl.innerHTML = "<div><span>¿Necesitas ayuda? </span><span>Echa un vistazo a nuestros productos más vendidos o a nuestras colecciones</span></div>";
        }
        else if(lang == "fr") {
            mainTitleEl.innerText = 'AUCUNE RÉSULTAT TROUVÉ.';
            secondTitleEl.innerText = 'Soit l’article n’est pas en stock, soit il y a une faute de saisie.';
            bestSellersMsgEl.innerHTML = "<div><span>Besoin d'aide ? </span><span>Consultez nos meilleures ventes ou nos collections.</span></div>";
        }
        else if(lang == "it") {
            mainTitleEl.innerText = 'NESSUN RISULTATO TROVATO.';
            secondTitleEl.innerText = 'O l’articolo non è disponibile, oppure c’è un errore di digitazione.';
            bestSellersMsgEl.innerHTML = "<div><span>Hai bisogno di aiuto? </span><span>Dai un’occhiata ai nostri Bestseller o alle nostre Collezioni.</span></div>";
        }
        else if(lang == "nl") {
            mainTitleEl.innerText = 'GEEN RESULTATEN GEVONDEN.';
            secondTitleEl.innerText = 'Of we hebben het niet op voorraad, of er is een typfout.';
            bestSellersMsgEl.innerHTML = "<div><span>Hulp nodig? </span><span>Bekijk onze bestsellers of collecties.</span></div>";
        }
        else {
            mainTitleEl.innerText = 'No matches found.';
            secondTitleEl.innerText = 'Either we don’t have it in stock, or you need to turn on that spell check.';
            bestSellersMsgEl.innerHTML = "<div><span>Need help? </span><span>Check out our Best Sellers or Collections.</span></div>";
        }
        noResElement.appendChild(mainTitleEl);
        noResElement.appendChild(secondTitleEl);
        noResElement.appendChild(bestSellersMsgEl);
    });
}


function upsellhooks() {

    window.FastRecommendationWidget.registerHook('upsell-cross-sell-products', ({
        products,
        element
    }) => {
        if(element.closest(".widget-main"))
        {
          element.closest(".widget-main").querySelector(".widget-container").style.width="fit-content";
          if(element.closest(".widget-main").querySelector(".fs-recommendation-right-arrow"))
          {
            element.closest(".widget-main").querySelector(".fs-recommendation-right-arrow").style.width="fit-content";      
            element.closest(".widget-main").querySelector(".fs-recommendation-right-arrow").setAttribute("aria-label", "right-arrow");
          }
          if(element.closest(".widget-main").querySelector(".fs-recommendation-left-arrow"))
          {
            element.closest(".widget-main").querySelector(".fs-recommendation-left-arrow").style.width="fit-content";
            element.closest(".widget-main").querySelector(".fs-recommendation-left-arrow").setAttribute("aria-label", "left-arrow");
          }

        }        

        element.querySelectorAll('.image.fs-rec-widget-1nuzme6').forEach(img => {
            img.setAttribute("loading", "lazy");
        });

        element.querySelectorAll(".fs-recommendation-product-name-wrapper").forEach((title) => {
            var modifiedTextContent = title.textContent.split(" - ")[0];
            // Set the modified text content back to the element
            title.textContent = modifiedTextContent;
        });

        element.querySelectorAll(".fs-recommendation-product-price").forEach((price) => {
            price.innerHTML = price.innerHTML.replace("From", "");
        });

        // for just add button without variants
        if (element.querySelector(".fs-rec-widget-dpdhay")) {
            element.querySelector(".fs-rec-widget-dpdhay").addEventListener('click', () => {
                element.querySelector(".fs-rec-widget-dpdhay .first").innerHTML = "ADDED!";
                setTimeout(() => {
                    element.querySelector(".fs-rec-widget-dpdhay .first").innerHTML = "ADD";
                }, 2000);
            });
        }
        //for quick add, it adds but need to refresh the cart
        if (element.querySelector(".fs-quick-add-button-wrapper")) {
            element.querySelectorAll(".fs-quick-add-button-wrapper").forEach(item => {
                if (item.closest('.fs-recommendation-product-container[data-id]')) {
                    let pId = item.closest('.fs-recommendation-product-container[data-id]').getAttribute('data-id');
                    if (products && pId && products[pId] && products[pId].variants && products[pId].variants.length == 1 && products[pId].variants[0] && products[pId].variants[0].id) {
                        let firstVarId = products[pId].variants[0].id;

                        // Clone the element
                        var clonedAddToCartBtnElement = item.cloneNode(true);
                        // Add a new click handler to the cloned element
                        clonedAddToCartBtnElement.addEventListener('click', function(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            productAddToCartCallback(firstVarId);
                            setTimeout(document.querySelector('#cart-icon-bubble').click(), 500);

                          // fix bug: Back Button Bug 
                            let cart_count_bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
                            let cart_item_count_text = cart_count_bubble.querySelector('[aria-hidden="true"]').innerText;
                            console.log("cart item count = " + cart_item_count_text);
                            var item_count = parseInt(cart_item_count_text, 10); // You want to use radix 10
                            item_count += 1;

                            let count_HTML = `<span aria-hidden="true">${item_count}</span>
    <span class="visually-hidden">${item_count} items</span>`;
                            console.log("fs add button clicked" + count_HTML);
                            cart_count_bubble.innerHTML = count_HTML;
                        });
                        // Append the cloned element to the body or another container
                        item.parentElement.appendChild(clonedAddToCartBtnElement);
                        item.style.display = 'none';
                    }

                }
                item.addEventListener('click', (event) => {
                    // setTimeout(() => {
                        event.preventDefault();
                        event.stopPropagation();
                        element.querySelectorAll(".quick-option").forEach((op) => {
                            op.addEventListener('click', () => {
                                setTimeout(() => {
                                    if (document.body.querySelector("cart-drawer")) {
                                        document.body.querySelector("cart-drawer").classList.remove("is-empty");
                                        if (document.body.querySelector(".drawer__inner-empty")) {
                                            document.body.querySelector(".drawer__inner-empty").remove();
                                        }
                                    }
                                    publish(PUB_SUB_EVENTS.cartUpdate, {});
                                    publish(PUB_SUB_EVENTS.quantityUpdate, {});

                                    if (!document.querySelector("cart-drawer").classList.contains("active")) {
                                        document.querySelector('.header__icon--cart').click();
                                    }
                                }, 2500);
                            });
                        });
                    // }, 100);
                });
            })
        }

        //for quick add, it adds but need to refresh the cart, for mobile
        if (element.querySelector(".show-fs-mobile-quick-add-button-wrapper")) {
            element.querySelectorAll(".show-fs-mobile-quick-add-button-wrapper").forEach(item => {
                if (item.closest('.fs-recommendation-product-container[data-id]')) {
                    let pId = item.closest('.fs-recommendation-product-container[data-id]').getAttribute('data-id');
                    if (products && pId && products[pId] && products[pId].variants && products[pId].variants.length == 1 && products[pId].variants[0] && products[pId].variants[0].id) {
                        let firstVarId = products[pId].variants[0].id;
                        // Clone the element
                        var clonedAddToCartBtnElement = item.cloneNode(true);
                        // Add a new click handler to the cloned element
                        clonedAddToCartBtnElement.addEventListener('click', function(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            productAddToCartCallback(firstVarId);
                            setTimeout(document.querySelector('.header__icon--cart').click(), 500);

                          // fix bug: Back Button Bug 
                            let cart_count_bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
                            let cart_item_count_text = cart_count_bubble.querySelector('[aria-hidden="true"]').innerText;
                            console.log("cart item count = " + cart_item_count_text);
                            var item_count = parseInt(cart_item_count_text, 10); // You want to use radix 10
                            item_count += 1;

                            let count_HTML = `<span aria-hidden="true">${item_count}</span>
    <span class="visually-hidden">${item_count} items</span>`;
                            console.log("fs add button clicked" + count_HTML);
                            cart_count_bubble.innerHTML = count_HTML;
                        });
                        // Append the cloned element to the body or another container
                        item.parentElement.appendChild(clonedAddToCartBtnElement);
                        item.style.display = 'none';
                    }
                }
                item.addEventListener('click', () => {
                    setTimeout(() => {
                        var mobileOptionFather = element.parentElement.parentElement.parentElement.previousElementSibling.previousElementSibling.previousElementSibling;
                        if (mobileOptionFather) {
                            mobileOptionFather.querySelectorAll(".quick-option").forEach((op) => {
                                op.addEventListener('click', () => {
                                    setTimeout(() => {
                                        if (document.body.querySelector("cart-drawer")) {
                                            document.body.querySelector("cart-drawer").classList.remove("is-empty");
                                            if (document.body.querySelector(".drawer__inner-empty")) {
                                                document.body.querySelector(".drawer__inner-empty").remove();
                                            }
                                        }
                                        publish(PUB_SUB_EVENTS.cartUpdate, {});
                                        publish(PUB_SUB_EVENTS.quantityUpdate, {});

                                        if (!document.querySelector("cart-drawer").classList.contains("active")) {
                                            document.querySelector('.header__icon--cart').click();
                                        }
                                    }, 2500);
                                });
                            });
                        }
                    }, 100);
                });
            })
        }
    });
}

var globalindex = -1
var input = "";

function achooks() {
    FastAutocomplete.registerHook('render-autocomplete-product-item', ({
        product,
        index,
        element
    }) => {
        setTimeout(() => {
            myACProductsArray = [];
            input = element.closest(".products").innerHTML;
            element.closest(".products").querySelectorAll(".fast-ac-item").forEach((item) => {
                addStringAndObjectToArray(item.querySelector(".title").textContent.split(" - ")[0], item, myACProductsArray)
            })
        }, 100)

        try {
            setTimeout(() => {
                let containers = document.querySelectorAll('.fast-ac-container');
                let l = containers.length;
                for (let i = 0; i < l; i++) {
                    let item = containers[i];
                    if (item.shadowRoot.querySelector('div.autocomplete')) {
                        if (item.shadowRoot) {
                            let selectedElement = item.shadowRoot.querySelector(`[data-id="${product.id}"]`);
                            if (selectedElement) {


                                HideOOSfromAutocomplete(product, selectedElement)

                                var modifiedTextContent = product.l.split(" - ")[0];
                                if (modifiedTextContent) {
                                    // Set the modified text content back to the element
                                    selectedElement.querySelector(".title").textContent = modifiedTextContent;
                                }

                                // Get the text content of the element
                                var originalText = selectedElement.querySelector(".fs-price").innerHTML.replace("From", "");

                                // Use regular expression to extract the numeric part
                                var numericValue = originalText.match(/\d+\.\d+/);

                                // Check if numericValue is not null (i.e., a numeric part is found)
                                if (numericValue) {
                                    // Ensure the replacement value has 2 decimal points
                                    var formattedValue = parseFloat(product.p).toFixed(2);
                                
                                    // Replace the numeric part with your desired value (e.g., 200.00)
                                    var replacedText = originalText.replace(/\d+\.\d+/, formattedValue);
                                }
                                // selectedElement.querySelector(".fs-price").innerHTML = selectedElement.querySelector(".fs-price").innerHTML.replace("From", "");
                            }
                        }

                    }
                }
            }, 50)

        } catch (error) {
            console.log(error);
        }
    });
}



// execution here
if (window.SerpOptions) {
    hooks();
} else {
    window.addEventListener('fast-serp-ready', function() {
        hooks();
    });
}

if (window.FastRecommendationWidget) {
    upsellhooks();
} else {
    window.addEventListener('fast-upsell-cross-sell-ready', function() {
        upsellhooks();
    });
}

if (window.FastAutocomplete) {
    achooks();
} else {
    window.addEventListener('fast-autocomplete-ready', function() {
        achooks();
    });
}